import { NotificationManager } from '@atlas/core';

export const FINISHED_BONUS_DETAILS_POPUP_ID = 'finishedBonusDetailsPopup';

export const showFinishedBonusDetails = data => {
  NotificationManager.removeNotification(FINISHED_BONUS_DETAILS_POPUP_ID);

  NotificationManager.display({
    data,
    id: FINISHED_BONUS_DETAILS_POPUP_ID,
    type: 'finishedBonusDetails',
  });
};
